// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"14":"360de6bb","15":"0c1ec8fc","855":"7a7c5ffd","966":"b3a7d616"}[chunkId] + ".css";
};